<app-new-custom-field-shared
  [breadCrumbInputs]="breadCrumbInputs"
  [isForPopup]="false"
  [isForEnabled] = "false"
></app-new-custom-field-shared>
